// removed by extract-text-webpack-plugin
module.exports = {"article":"src-templates----about-module---article---17Ys3","articleTitle":"src-templates----about-module---articleTitle---1bq-F","articleContent":"src-templates----about-module---articleContent---23muN","component":"src-templates----about-module---component---1yXGA"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/about.module.scss
// module id = 88
// module chunks = 10991734084388 32239989425883 95715928098905